import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=135bc268&lang=pug"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&id=135bc268&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports